import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export function getLocationId(state) {
  state.locationId = cookies.get("location_id");
  return state.locationId;
}

export function getLocationName(state) {
  const cookieValue = cookies.get("location_name");
  state.locationName = cookieValue;
  return state.locationName;
}

export function getAppName(state) {
  const cookieValue = cookies.get("location_app_name");
  state.appName = cookieValue ?? "Brain Trainer";
  return state.appName;
}

export function getLocationLogo(state) {
  state.locationLogo = cookies.get("location_logo");
  return state.locationLogo;
}

export function getLocations(state) {
  return state.locations;
}
